import { selectAppConfig } from "./selectAppConfig";
import { SwitchType } from "helpers/constants";

export const selectSmsVerifyRequired = (state) => selectAppConfig(state).sms_verify_required === SwitchType.ON;
